import { render } from "./SelectPetsComponent.vue?vue&type=template&id=7a04841e"
import script from "./SelectPetsComponent.vue?vue&type=script&lang=js"
export * from "./SelectPetsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__